module.exports = __webpack_public_path__ + "static/media/favicon06.9d032c1a.webp";